import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { SaveFormDeclaration } from '../models/SaveFormDeclaration';
import { SharingService } from 'src/app/modules/shared/shared.service';

@Injectable({
    providedIn: 'root'
})
export class DeclarationService {
    

    APIURL = environment.apiURL;
    serviceUrl: string;
    ChangeRequestUri: string;
  constructor(private httpClient: HttpClient, private sharingService: SharingService) {
    }

    SaveDeclaration1(formData : SaveFormDeclaration): Observable<any> { 
        this.ChangeRequestUri = this.APIURL + "api/declaration/save";
        return this.httpClient.post<any>(this.ChangeRequestUri, formData,{
          headers: this.sharingService.createAuthorizationHeader()
        });
    }

    UploadFile(requestObj): Observable<any> {
        var Uri = this.APIURL + "api/user/uploadedDocuments";
        return this.httpClient.post<any>(Uri, requestObj,{
          headers: this.sharingService.createAuthorizationHeader()
        });
      }
      downloadPdfService(pdfInputData): Observable<any> {
        const uri = `${this.APIURL + "api/user/downloadPdfService"}/${pdfInputData}`;
        return this.httpClient.post<any>(uri,pdfInputData,{
          headers: this.sharingService.createAuthorizationHeader()
        });
      }
}
